import { render, staticRenderFns } from "./LookChat.vue?vue&type=template&id=6cb99188&scoped=true&"
import script from "./LookChat.vue?vue&type=script&lang=js&"
export * from "./LookChat.vue?vue&type=script&lang=js&"
import style0 from "./LookChat.vue?vue&type=style&index=0&id=6cb99188&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb99188",
  null
  
)

export default component.exports